import { NumberEffect } from '@organisms/GenesisEs/Utils';
import React from 'react';
import styled from 'styled-components';

type Props = {
    totalCount: number;
    delay?: number;
};

const defaultDelay = 500;

const ShowNumber = (props: Props) => {
    const { totalCount, delay } = props;
    return (
        <>
            <NumberWithStyled>
                <NumberEffect number={totalCount} delay={delay ?? defaultDelay} />
            </NumberWithStyled>
            <UnitWithStyled>件</UnitWithStyled>
        </>
    );
};
const NumberWithStyled = styled.span`
    display: inline-block;
    height: 50px;
    font-size: 38px;
    font-weight: bold;
    padding-left: 10px;
    letter-spacing: 1px;
    animation-name: animation-fadein;
    animation-duration: .5s;
    animation-fill-mode: forwards;
`
const UnitWithStyled = styled.span`
    font-size: 14px;
    font-weight: normal;
    padding-left: 10px;
`

export default ShowNumber;